import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-aboutpage-history',
    templateUrl: './aboutpage-history.component.html',
    styleUrls: ['./aboutpage-history.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AboutpageHistoryComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

    sectionTitle: sectionTitleContent[] = [
        {
            subTitle: "Our History",
            title: 'History Begins in 2022',
            paragraphText: 'Devotory, founded in 2022, specializes in delivering innovative tech solutions and exceptional IT talent worldwide.'
        }
    ]
    historyTimeline: TimelineBlock[] = [
        {
            year: '2022',
            date: 'December 20',
            title: 'Founded',
            paragraphText: 'Devotory was founded in 2022 with a vision to revolutionize the tech industry by delivering innovative solutions and exceptional IT talent globally. The company quickly established itself as a leader in leveraging cutting-edge technologies to solve complex business challenges and enhance customer experiences.',
            img: 'assets/img/history/img1.jpg'
        },
        {
            year: '2023',
            date: 'February 25',
            title: 'Expansion',
            paragraphText: 'Expanded operations to USA and Europe, establishing a global presence and serving clients in diverse markets.',
            img: 'assets/img/history/img3.jpg'
        },
        {
            year: '2023',
            date: 'July 14',
            title: 'Global Success',
            paragraphText: 'In July 2023, we forged an exclusive global tech partnership with one of the USAs leading AI search engine ASA Help, establishing the foundation of its core AI engine. This engine leverages NLP/LLM to deliver tailored results for user queries, optimizing online shopping by finding the perfect item matches.',
            img: 'assets/img/history/img2.jpg'
        },
        // {
        //     year: '2023',
        //     date: 'December 10',
        //     title: 'International Award',
        //     paragraphText: 'Real innovations and a positive customer experience are the heart of successful communication. Lorem ipsum dolor sit amet, sectetur adipiscing elit, tempor incididunt ut labore et dolore magna.',
        //     img: 'assets/img/history/img4.jpg'
        // }
    ]

}
class sectionTitleContent {
    subTitle : string;
    title : string;
    paragraphText : string;
}
class TimelineBlock {
    year : string;
    date : string;
    title : string;
    paragraphText : string;
    img : string;
}